import React from "react";
import GenericCRUD from "@/components/common/GenericCRUD";

const config = {
  resource: "popups",
  singular: "popup",
  title: "Popups",
  subtitle: "Announcement and newsletter modals with trigger rules.",
  titleKey: "title",
  statusFilter: ["active", "draft"],
  columns: [
    { key: "title", label: "Title", render: (r) => <span className="text-white font-medium">{r.title}</span> },
    { key: "type", label: "Type" },
    { key: "trigger", label: "Trigger" },
    { key: "conversions", label: "Conversions" },
    { key: "status", label: "Status", badge: true, className: "w-32" },
  ],
  fields: [
    { key: "title", label: "Title", type: "text" },
    { key: "type", label: "Type", type: "select", options: [
      { label: "Announcement", value: "announcement" },
      { label: "Newsletter", value: "newsletter" },
      { label: "Cookie Consent", value: "cookie_consent" },
    ]},
    { key: "trigger", label: "Trigger", type: "select", options: [
      { label: "On Load", value: "on_load" },
      { label: "On Exit", value: "on_exit" },
      { label: "On Scroll", value: "on_scroll" },
      { label: "Time-based", value: "time_based" },
    ]},
    { key: "delay_seconds", label: "Delay (seconds)", type: "number" },
    { key: "content", label: "Content", type: "textarea" },
    { key: "cta_label", label: "CTA Label", type: "text" },
    { key: "cta_url", label: "CTA URL", type: "text" },
    { key: "status", label: "Status", type: "select", options: [
      { label: "Active", value: "active" }, { label: "Draft", value: "draft" }
    ]},
  ],
  defaultValues: { status: "draft", delay_seconds: 5, conversions: 0, impressions: 0, target_pages: [] },
};

export default function Popups() { return <GenericCRUD config={config} />; }
